import type { BacktestWatchlistItem } from "@/types/backtest"

export type StrategyType = "LiquidShares" | "DailyWeekly" | "MixTrading" | "Manual"

export const STRATEGY_TYPE_LABELS: Record<StrategyType, string> = {
  LiquidShares: "유동주식수",
  DailyWeekly:  "일봉주봉",
  MixTrading:   "믹스매매",
  Manual:       "수동선택",
}

export type PositionMode  = "amount" | "quantity"
export type BuyPriceType  = "CurrentPrice" | "Open" | "High" | "Low"
export type Comparison    = "GreaterEqual" | "LessEqual"
export type QtyMode       = "amount" | "quantity"
export type SellTargetMode = "amount" | "percent"
export type SellQtyMode    = "amount" | "quantity" | "percent"

export const BUY_PRICE_TYPE_LABELS: Record<BuyPriceType, string> = {
  CurrentPrice: "현재가",
  Open:         "시가",
  High:         "고가",
  Low:          "저가",
}

export const COMPARISON_LABELS: Record<Comparison, string> = {
  GreaterEqual: "이상",
  LessEqual:    "이하",
}

export interface AutoTradingStockSetting {
  stockCode: string
  isActive: boolean
  accountNumber: string
  strategyType: StrategyType
  positionMode: PositionMode
  positionValue: number
  enableBuy: boolean
  enableSell: boolean

  buyPriceType: BuyPriceType | null
  buyPriceValue: number | null
  buyComparison: Comparison | null
  buyQtyMode: QtyMode | null
  buyQtyValue: number | null

  sellTargetMode: SellTargetMode | null
  sellTargetValue: number | null
  sellQtyMode: SellQtyMode | null
  sellQtyValue: number | null
}

export interface AutoTradingStockListItem extends BacktestWatchlistItem {
  isActive: boolean
  strategyType: StrategyType
  enableBuy: boolean
  enableSell: boolean
}
